// extracted by mini-css-extract-plugin
module.exports = {"companyOpacity":"src-common-components-Wrapper-__styles-module___companyOpacity"};